<header class="ib-modals__header">
    <h2 class="ib-heading ib-heading--type-1">{{'GIFT_CARD_MODAL_BACK_TITLE'|translate}}</h2>
</header>
<section class="ib-modals__body">
    <div class="ib-layout__line-spacing--large">
        <p class="ib-text ib-text--block">{{'GIFT_CARD_MODAL_BACK_SUBTITLE'|translate}}</p>
    </div>
</section>
<footer class="ib-modals__footer">
    <div class="ib-content-buttons">
        <div class="ib-content-buttons__content-left">
            <button id="bbki-back-header-accept-btn" class="ib-button ib-button--w-medium" type="button" title="{{'GIFT_CARD_MODAL_BACK_CANCEL'|translate}}" (click)="accept()">{{'HEADER_CONFIRMATION_BACK_MODAL_ACCEPT'|translate}}</button>
        </div>
        <div class="ib-content-buttons__content-right">
            <a id="bbki-back-header-cancel-link" class="ib-link" href="javascript:void(0)" title="{{'GIFT_CARD_MODAL_BACK_OK'|translate}}" (click)="close()">{{'HEADER_CONFIRMATION_BACK_MODAL_LINK'|translate}}</a>
        </div>
    </div>
</footer>
